import { useEffect, useRef } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

/**
 * Wraps routes that require authentication.
 * - While loading: shows a full-page spinner
 * - Not authenticated: redirects to /login?from=<current path>
 * - Authenticated: renders nested <Outlet />
 */
export default function ProtectedRoute() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirected = useRef(false);

  useEffect(() => {
    if (!isLoading && !user && !redirected.current) {
      redirected.current = true;
      const from = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?from=${from}`, { replace: true });
    }
  }, [isLoading, user, navigate, location]);

  // Reset redirect flag when user logs in
  useEffect(() => {
    if (user) redirected.current = false;
  }, [user]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900 flex flex-col items-center justify-center gap-4">
        <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm text-gray-500 dark:text-gray-400">Đang kiểm tra phiên đăng nhập...</p>
      </div>
    );
  }

  if (!user) {
    // Render nothing while redirect is happening
    return null;
  }

  return <Outlet />;
}